import type { ApiResponse } from '@/shared/types';
import api from '@/shared/api/client';

export const operatorLogsApi = {
  listAuditLogs: (params?: Record<string, any>) =>
    api.get<ApiResponse<any>>('/operator/audit-logs', { params }),

  listAuditActions: () =>
    api.get<ApiResponse<string[]>>('/operator/audit-logs/actions'),

  listEmailLogs: (params?: Record<string, any>) =>
    api.get<ApiResponse<any>>('/operator/email-logs', { params }),

  listWebhookLogs: (params?: Record<string, any>) =>
    api.get<ApiResponse<any>>('/operator/webhook-logs', { params }),

  sendTestEmail: (to: string) =>
    api.post<ApiResponse<any>>('/operator/email/test', { to }),

  getEmailLog: (id: string) =>
    api.get<ApiResponse<any>>(`/operator/email-logs/${id}`),

  retryEmailLog: (id: string) =>
    api.post<ApiResponse<any>>(`/operator/email-logs/${id}/retry`),

  listEmailTemplates: () =>
    api.get<ApiResponse<any[]>>('/operator/email-templates'),

  createEmailTemplate: (data: any) =>
    api.post<ApiResponse<any>>('/operator/email-templates', data),

  updateEmailTemplate: (id: string, data: any) =>
    api.put<ApiResponse<any>>(`/operator/email-templates/${id}`, data),

  previewEmailTemplate: (id: string, data: any, params?: { tenantId?: string }) =>
    api.post<ApiResponse<any>>(`/operator/email-templates/${id}/preview`, data, { params }),

  previewEmailTemplateDraft: (data: any, params?: { tenantId?: string }) =>
    api.post<ApiResponse<any>>('/operator/email-templates/preview-draft', data, { params }),

  getEmailVariables: () =>
    api.get<ApiResponse<any[]>>('/operator/email/variables'),
};
